
export const BuyerReturnMutation = new TypedDocumentString(`
    mutation BuyerReturnMutation($input: InputBuyerReturn!) {
  buyerReturn(input: $input) {
    responseInfo {
      ...ResponseInfo
      __typename
    }
    doc {
      ...SellerReturnFull
      __typename
    }
    __typename
  }
}
    fragment ProductPriceLineItem on ProductPriceLineItem {
  qty
  price {
    priceForHumans
    number
    __typename
  }
  ui {
    ...DiscountUi
    __typename
  }
  __typename
}
fragment ProductListingBoxUiPrice on ProductListingBoxUiPrice {
  bulk {
    price
    qty
    __typename
  }
  endAt
  publicCode {
    code
    percent
    price {
      priceForHumans
      number
      __typename
    }
    __typename
  }
  price {
    priceForHumans
    number
    __typename
  }
  priceTaxless {
    priceForHumans
    number
    __typename
  }
  priceOld {
    priceForHumans
    number
    __typename
  }
  lineItems {
    ...ProductPriceLineItem
    __typename
  }
  __typename
}
fragment ProductListingBoxUiPriceFull on ProductListingBoxUiPrice {
  ...ProductListingBoxUiPrice
  _limited {
    limit
    left
    leftPercent
    __typename
  }
  __typename
}
fragment ProductBoxImages on ListingBoxImages {
  id
  slug
  imageBox {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ProductSettingsQty on ProductSettingsQty {
  min
  max
  step
  unit
  stockMsg
  __typename
}
fragment ProductOptionsItem on ProductOptionsItem {
  key
  name
  guideProductId
  guideBodyId
  values {
    name
    hsla {
      ...DocumentColorHsla
      __typename
    }
    image {
      ...ImageNodeItem
      __typename
    }
    product {
      productId
      title
      inStock
      slug
      image {
        ...ImageNodeItem
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment ProductListingValues on ProductListingValues {
  variantCount
  variantAvailableCount
  variantBoxList {
    ...ProductBoxImages
    __typename
  }
  stock
  inStock
  options {
    ...ProductOptionsItem
    __typename
  }
  _uiPrice {
    ...ProductListingBoxUiPriceFull
    __typename
  }
  __typename
}
fragment ProductListingBox on ProductListingBox {
  id
  groupId
  sellerId
  sku
  color
  departmentName
  isNew
  slug
  title
  availabilityType
  availableAt
  quantityLimit
  privateVisibility
  _values {
    ...ProductListingValues
    __typename
  }
  option {
    key
    uiKey
    uiValue
    __typename
  }
  settingsQty {
    ...ProductSettingsQty
    __typename
  }
  rating {
    count
    rating
    __typename
  }
  imageCount
  images {
    ...ImageNodeItem
    __typename
  }
  img1
  returnsNotAllowed
  __typename
}
fragment DiscountUi on DiscountUi {
  msg
  amount
  __typename
}
fragment ResponseInfo on ResponseInfo {
  success
  message
  status
  error
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment Duration on Duration {
  unit
  value
  __typename
}
fragment ProductExtraReturn on ProductExtraReturn {
  id
  returnsNotAllowed
  document {
    _id
    __typename
  }
  title {
    value
    __typename
  }
  message {
    value
    __typename
  }
  duration {
    ...Duration
    __typename
  }
  __typename
}
fragment ProductExtraShop on ProductExtraShop {
  id
  title {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  address {
    value
    __typename
  }
  city {
    value
    __typename
  }
  contacts {
    ...SellerContacts
    __typename
  }
  document {
    _id
    __typename
  }
  __typename
}
fragment OpeningHoursHour on OpeningHoursHour {
  hour
  min
  __typename
}
fragment OpeningHoursDay on OpeningHoursDay {
  open24
  close
  hours {
    open {
      ...OpeningHoursHour
      __typename
    }
    close {
      ...OpeningHoursHour
      __typename
    }
    __typename
  }
  __typename
}
fragment SellerContacts on SellerContacts {
  emails
  tels
  openingHours {
    timezone
    mon {
      ...OpeningHoursDay
      __typename
    }
    tue {
      ...OpeningHoursDay
      __typename
    }
    wed {
      ...OpeningHoursDay
      __typename
    }
    thu {
      ...OpeningHoursDay
      __typename
    }
    fri {
      ...OpeningHoursDay
      __typename
    }
    sat {
      ...OpeningHoursDay
      __typename
    }
    sun {
      ...OpeningHoursDay
      __typename
    }
    __typename
  }
  links {
    type
    handle
    __typename
  }
  __typename
}
fragment SellerOrderUiStatusValue on SellerOrderUiStatusValue {
  delivery
  order
  payment
  __typename
}
fragment SellerOrderUiStatus on SellerOrderUiStatus {
  status {
    ...SellerOrderUiStatusValue
    __typename
  }
  history {
    at
    status {
      ...SellerOrderUiStatusValue
      __typename
    }
    __typename
  }
  __typename
}
fragment SellerOrderDocProduct on SellerOrderDocProduct {
  qty
  priceUnitFinal {
    priceForHumans
    number
    __typename
  }
  lineItems {
    ...ProductPriceLineItem
    __typename
  }
  priceTotalFinal {
    priceForHumans
    __typename
  }
  returnDoc {
    ...ProductExtraReturn
    __typename
  }
  product {
    id
    title {
      value
      __typename
    }
    image
    imageFull {
      ...Image
      __typename
    }
    description {
      value
      __typename
    }
    departments {
      value
      __typename
    }
    option {
      value
      __typename
    }
    __typename
  }
  __typename
}
fragment SellerOrderProductsListing on SellerOrderProductsListing {
  isAllowToReturn
  qtyAllowedToReturn
  isManual
  returnUntil
  ref {
    ...SellerOrderDocProduct
    __typename
  }
  listing {
    ...ProductListingBox
    __typename
  }
  __typename
}
fragment SellerOrderDocItem on SellerOrderDoc {
  _id
  prettyId
  createdAt
  productCount
  prices {
    ...PaymentPrices
    __typename
  }
  statusDelivery
  statusOrder
  statusPayment
  uiBox {
    isAllowToReturn
    coupon
    address {
      ...BuyerAddress
      __typename
    }
    statusUi
    status {
      status {
        ...SellerOrderUiStatusValue
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment SellerOrderDelivery on SellerOrderDelivery {
  type
  deliveryId
  title {
    value
    __typename
  }
  description {
    value
    __typename
  }
  __typename
}
fragment OrderLockerInfo on OrderLockerInfo {
  city
  provider
  name
  address
  postCode
  country
  description
  __typename
}
fragment SellerOrderDocFull on SellerOrderDoc {
  ...SellerOrderDocItem
  sellerId
  _sf {
    repeat
    hasInvoicePdf
    shipments {
      ...SellerShipment
      __typename
    }
    lockerInfo {
      ...OrderLockerInfo
      __typename
    }
    delivery {
      ...SellerOrderDelivery
      __typename
    }
    status {
      ...SellerOrderUiStatus
      __typename
    }
    deliveryCity {
      value
      __typename
    }
    deliveryCountry {
      ...BuyerAddressCountry
      __typename
    }
    shop {
      ...ProductExtraShop
      __typename
    }
    __typename
  }
  _listingsAll {
    ...SellerOrderProductsListing
    __typename
  }
  __typename
}
fragment BuyerAddressCountry on BuyerAddressCountry {
  iso2
  __typename
}
fragment BuyerAddress on BuyerAddress {
  _id
  _fullname
  name
  lastname
  street
  apartment
  city
  state
  tel
  postCode
  country {
    ...BuyerAddressCountry
    __typename
  }
  deliveryInstruction
  type
  __typename
}
fragment Price2 on Price2 {
  total {
    priceForHumans
    number
    __typename
  }
  __typename
}
fragment PaymentPrices on PaymentPrices {
  _ui {
    delivery {
      ...Price2
      __typename
    }
    products {
      ...Price2
      __typename
    }
    giftcards {
      ...Price2
      __typename
    }
    final {
      ...Price2
      __typename
    }
    productOld {
      ...Price2
      __typename
    }
    deliveryOld {
      ...Price2
      __typename
    }
    totalSavings {
      ...Price2
      __typename
    }
    taxesPayed {
      ...Price2
      __typename
    }
    taxfull {
      ...Price2
      __typename
    }
    taxfullTaxes {
      ...Price2
      __typename
    }
    taxless {
      ...Price2
      __typename
    }
    taxInfo {
      ...BuyerTaxInfo
      __typename
    }
    isTaxed
    __typename
  }
  __typename
}
fragment BuyerTaxInfo on BuyerTaxInfo {
  iso2
  vatSize
  isTaxed
  goodsForEuCommercialUse
  __typename
}
fragment SellerShipment on SellerShipment {
  _id
  shipped
  deliveryId
  trackingProvider
  trackingType
  estimatedDeliveryDate
  isFullShipment
  deliveryCourierName
  update {
    url
    number
    __typename
  }
  number {
    number
    __typename
  }
  status
  lastUpdate
  _urls {
    code
    full
    __typename
  }
  lockerInfo {
    ...OrderLockerInfo
    __typename
  }
  products {
    productId
    qty
    __typename
  }
  __typename
}
fragment SellerReturnReason on SellerReturnReason {
  txt {
    value
    __typename
  }
  __typename
}
fragment SellerReturnProduct on SellerReturnProduct {
  productId
  qty
  comment
  cancelReason {
    ...SellerReturnReason
    __typename
  }
  returnReason {
    ...SellerReturnReason
    __typename
  }
  __typename
}
fragment SellerReturn on SellerReturn {
  _id
  ran
  orderPrettyId
  createdAt
  status
  products {
    ...SellerReturnProduct
    __typename
  }
  refundTotal {
    total {
      priceForHumans
      __typename
    }
    __typename
  }
  __typename
}
fragment BuyerReturnTrackingNumberDetail on BuyerReturnTrackingNumberDetail {
  trackingNumber
  courier
  __typename
}
fragment SellerReturnFull on SellerReturn {
  ...SellerReturn
  trackingNumbers {
    ...BuyerReturnTrackingNumberDetail
    __typename
  }
  bank {
    bankSwift
    bankTitle
    bankAccountNumber
    bankAcconutHolderName
    __typename
  }
  history {
    at
    status
    __typename
  }
  _orderBuyer {
    ...SellerOrderDocFull
    __typename
  }
  _products {
    total {
      total {
        priceForHumans
        __typename
      }
      __typename
    }
    item {
      ...SellerReturnProduct
      __typename
    }
    listing {
      ...ProductListingBox
      __typename
    }
    __typename
  }
  __typename
}`, {"hash":"32b2642a85673d6a668c64b10bbbbe9720896865d7566e0c356c9feef50eeb7e"});